import get from 'lodash/get';

export default function getPentagramFromPage(page: object): string {
  return get(page, 'region.pentagram', '');
}
